import { projects } from '../data/projects';
import { archiveProjects } from '../data/archiveProjects';

const allProjects = [...projects, ...archiveProjects];

/** Preferred public URL for a project (slug-based, SEO-friendly). */
export function getProjectCanonicalPath(project) {
  if (!project?.slug) return null;
  if (project.path && !/^\/project\/\d+$/i.test(project.path)) {
    return project.path;
  }
  return `/${project.slug}`;
}

const PROJECT_SEO_ROUTES = allProjects.map((project) => ({
  slug: project.slug,
  path: getProjectCanonicalPath(project),
  project,
}));

export function getProjectByCanonicalPath(pathname) {
  return PROJECT_SEO_ROUTES.find((entry) => entry.path === pathname)?.project ?? null;
}
